import { BankCodes, CardCodes, OrganizationCodes } from '@revenuemarket/bank';

import { API } from '~apis/axios/instance';
import { AccountType } from '~models/bank/enum';
import { SimpleBankAccount } from '~models/cashFlow';
import { ResponseBaseWithData } from '~types/response';

export interface IBankAccountScrapingStatusItem {
  accountId: number;
  accountType: AccountType;
  bankCode: BankCodes;
  accountNumber: string;
  scrapedAt: string;
  status: SCRAPE_STATUS;
}

export type TAX_INVOICE_TYPE = 'SALES' | 'PURCHASE';

export interface LabelScrapingStatusItem {
  labeledAt: string;
  status: SCRAPE_STATUS;
}

export interface ISecurityAccountScrapingStatusItem {
  organizationCode: OrganizationCodes;
  scrapedAt: string;
  status: SCRAPE_STATUS;
}
export interface ITaxInvoiceScrapingStatusItem {
  type: TAX_INVOICE_TYPE;
  scrapedAt: string;
  status: SCRAPE_STATUS;
}

export type CASH_RECEIPT_TYPE = 'SALES' | 'PURCHASE';

export interface ICashReceiptScrapingStatusItem {
  type: CASH_RECEIPT_TYPE;
  scrapedAt: string;
  status: SCRAPE_STATUS;
}

export interface PurchasedCardSalesScrapingStatus {
  scrapedAt: string;
  status: SCRAPE_STATUS;
}

export type CardScrapeType = 'APPROVAL' | 'PURCHASE' | 'LIMIT' | 'BILLING' | 'PRE_PAYMENT';

export interface CardScrapeStatus {
  organizationCode: CardCodes;
  scrapedAt: string;
  status: SCRAPE_STATUS;
  type: CardScrapeType;
}

export const CARD_SCRAPE_TYPE_ORDER = ['APPROVAL', 'PURCHASE', 'LIMIT', 'BILLING', 'PRE_PAYMENT'];

export type SCRAPE_STATUS = 'SUCCESS' | 'IN_PROGRESS' | 'ERROR' | 'FATAL' | 'LABELING';

export interface NtsCertificate {
  id: number;
  status: 'NORMAL' | 'EXPIRED' | 'EXPIRE_SOON' | 'STALE';
}

export interface CardConnection {
  id: number;
  organizationCode: OrganizationCodes;
  status: 'CONNECTED' | 'DISCONNECTED';
}

export interface ScrapeStatusResponse {
  companyId: string;
  unlabeledCount: number;
  lastRequestedAt: string;
  overallStatus: SCRAPE_STATUS;
  lastRequestId: string;
  abnormalBankAccounts: SimpleBankAccount[];
  abnormalSecurityAccounts: SimpleBankAccount[];
  // 은행
  bankAccountScrapingStatus: IBankAccountScrapingStatusItem[];
  // 홈택스
  ntsCertificates: NtsCertificate[];
  taxInvoiceScrapingStatus: ITaxInvoiceScrapingStatusItem[];
  cashReceiptScrapingStatus: ICashReceiptScrapingStatusItem[];
  // 카드
  cardConnections: CardConnection[];
  cardScrapingStatus: CardScrapeStatus[];
  // 여신금융
  purchasedCardSalesScrapingStatus: PurchasedCardSalesScrapingStatus[];
  // 증권
  securityAccountListScrapingStatus: ISecurityAccountScrapingStatusItem[];
  labelingStatus: LabelScrapingStatusItem[];
}

/**
 * 통합 스크래핑 상태 조회
 * @param companyId 회사 id
 * @returns
 */
export const getIntegratedScrapeStatus = (companyId: string) => {
  return API.get<ResponseBaseWithData<ScrapeStatusResponse>>(
    `/api/v2/companies/${companyId}/integrated-scraping/status`,
  );
};

/**
 * 통합 스크래핑 요청
 * @param companyId 회사 id
 * @returns
 */
export const postIntegratedScraping = (companyId: string) => {
  return API.post<ResponseBaseWithData>(`/api/v2/companies/${companyId}/integrated-scraping`);
};

/**
 * 청구/선결제 내역 스크래핑 상태 요청
 * @param companyId 회사 id
 * @returns
 */
export const postBillingScraping = (companyId: string) => {
  return API.post<ResponseBaseWithData>(
    `/api/v2/companies/${companyId}/integrated-scraping/billings`,
  );
};
